import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { AdminAddProductFormComponent } from "../components";
import { AdminDefaultLayout } from "../layouts/adminDefaultLayout";
const columns = [
  { header: "Name", propName: "name" },
  { header: "Brand", propName: "brand.name" },
  { header: "Category", propName: "category.name" },
  // Add other columns as needed
];

const actions = [
  {
    name: "Edit",
    method: (item: any) => {
      /* handle edit */
    },
  },
  {
    name: "Delete",
    method: (item: any) => {
      /* handle delete */
    },
  },
];

export const AdminProductsComponent = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [inputs, setInputs] = useState({});

  const handleFormButtonClick = () => {
    setFormOpen(!formOpen);
  };
  return (
    <>
      <AdminDefaultLayout
        openForm={handleFormButtonClick}
        formButtonTitle="Product"
        actions={actions}
        columns={columns}
        header={"Products"}
        searchType="product"
      ></AdminDefaultLayout>
      <Modal show={formOpen} onHide={handleFormButtonClick} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Add Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AdminAddProductFormComponent closeForm={handleFormButtonClick} data={[]} setInputs={setInputs} />
        </Modal.Body>
      </Modal>
    </>
  );
};
